import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CampaignForm from '../../../components/forms/CampaignForm';
import { CampaignClient, CampaignDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from '../../../services/axiosInstance';

const CampaignCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new CampaignClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Causes', href: '/admin/campaigns' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CampaignDTO) => {
    setIsSubmitting(true);
    try {
      await apiClient.createCampaign(data);
      navigate('/admin/campaigns');
    } catch (error) {
      console.error('Error creating Cause:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Create Cause"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <CampaignForm
          initialValues={{} as CampaignDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/campaigns')}
        />
      </Card>
    </AdminLayout>
  );
};

export default CampaignCreate;
